var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.493,
    height: 24.432,
    viewBox: "0 0 29.493 24.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c75146;stroke:#c75146;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.139 0.126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.773 18.037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M477.093,154.411a1.876,1.876,0,1,1,1.833-1.876A1.857,1.857,0,0,1,477.093,154.411Zm0-2.875a1,1,0,1,0,.976,1A.988.988,0,0,0,477.093,151.536Z",
    transform: "translate(-475.26 -150.66)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.413,133.68H446.669a1.22,1.22,0,0,1-1.1-.692,1.292,1.292,0,0,1,.1-1.319l11.9-19.917a.792.792,0,0,1,.921-.329.812.812,0,0,1,.557.784v12.555a.989.989,0,1,0,1.978,0v-8.948a.428.428,0,1,1,.857,0v8.948a1.846,1.846,0,1,1-3.691,0V112.392l-11.815,19.768a.417.417,0,0,0-.051.434.367.367,0,0,0,.338.215H473.4a.367.367,0,0,0,.338-.215.386.386,0,0,0-.03-.4l-13.387-22.02a.445.445,0,0,1,.137-.6.425.425,0,0,1,.591.14l13.37,21.994a1.268,1.268,0,0,1,.081,1.293A1.216,1.216,0,0,1,473.413,133.68Z",
    transform: "translate(-445.433 -109.499)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.d46b7367e05433d54b1f30a86a45afef.svg";
export { ForwardRef as ReactComponent };